export default __webpack_public_path__ + "static/media/bloinxLogo.3b193d5b.png";